import React, { useMemo } from 'react';
import { PlusCircleOutlined } from '@ant-design/icons';
import { Button, Dropdown, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

export type LoraWanActivationTypes = 'unit' | 'batch' | 'token';

interface ActivationButtonProps {
  isRoot: boolean;
  onSelectedKey: (key: LoraWanActivationTypes) => void;
}

const ActivationButton = ({ isRoot, onSelectedKey }: ActivationButtonProps) => {
  const { t } = useTranslation('lorawan');

  const menuItems = useMemo(
    () => ['unit', 'batch'].map(item => ({ key: item, label: t(item) })),
    [t],
  );

  return (
    <Dropdown
      menu={{
        onClick: ({ key }) => onSelectedKey(key as LoraWanActivationTypes),
        items: menuItems,
      }}
      disabled={isRoot}
    >
      <Tooltip
        placement="top"
        title={isRoot ? t('inventory:root-cannot-see') : t('activation')}
      >
        <Button icon={<PlusCircleOutlined />} disabled={isRoot} />
      </Tooltip>
    </Dropdown>
  );
};

export default ActivationButton;
